import { datadogRum } from '@datadog/browser-rum';
import { datadogLogs } from '@datadog/browser-logs';
import { setDatadogData } from '@spa/shared/utils/datadog';
import PropTypes from 'prop-types';

datadogRum.init({
  applicationId: process.env.DATADOG_APP_ID,
  clientToken: process.env.DATADOG_CLIENT_TOKEN,
  site: 'datadoghq.com',
  service: process.env.DATADOG_SERVICE,
  env: process.env.ENV,
  version: process.env.GIT_HASH,
  sessionSampleRate: parseInt(process.env.DATADOG_SESSION_SAMPLE_RATE, 10) ?? 100,
  sessionReplaySampleRate: parseInt(process.env.DATADOG_SESSION_REPLAY_SAMPLE_RATE, 10) ?? 20,
  trackUserInteractions: true,
  trackResources: true,
  trackLongTasks: true,
  defaultPrivacyLevel: 'mask-user-input'
});

datadogLogs.init({
  clientToken: process.env.DATADOG_CLIENT_TOKEN,
  service: process.env.DATADOG_SERVICE,
  env: process.env.ENV,
  forwardErrorsToLogs: parseInt(process.env.DATADOG_LOGS_FORWARD_ERRORS, 10) === 1,
  sessionSampleRate: parseInt(process.env.DATADOG_LOGS_SAMPLE_RATE, 10) ?? 100
});

export default function DatadogInit({ datadog }) {
  setDatadogData(datadog?.user, datadog?.context?.bookingId);

  // Render nothing - this component is only included so that the init code
  // above will run client-side
  return null;
}

DatadogInit.propTypes = {
  datadog: PropTypes.object
};
